import React from 'react';
import './Footer.css';

import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { MdOutlineAlternateEmail } from 'react-icons/md';

const Footer = () => {

    return (
        <>
            <footer id="footer">
                <div className="container">
                    <div className="footer__header">
                        
                    </div>

                    <hr className="divider" />

                    <div className="footer__bottom">
                        <p className="copyright__text">© 2022 All right reserved Rostam.</p>
                        <div className="social__menu">
                            <a className='social__menu--link' href="/"><FaFacebookF/></a>
                            <a className='social__menu--link' href="/"><FaLinkedinIn/></a>
                            <a className='social__menu--link' href="/"><FaTwitter/></a>
                            <a className='social__menu--link' href="/"><MdOutlineAlternateEmail/></a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;